import { FC } from 'react';
import { noop } from 'lodash';

import classNames from 'classnames';

import LOGO from './Logo.png';

import styles from './Logo.module.scss';

export interface LogoProps {
  variant?: 'black' | 'white';
  height?: number;
  className?: string;
  onClick?: () => void;
}

export const Logo: FC<LogoProps> = ({
  variant,
  className,
  height = 52,
  onClick = noop,
}) => {
  return (
    <img
      src={LOGO}
      alt="Helpful"
      height={height}
      onClick={onClick}
      style={{ height }}
      className={classNames(styles.root, styles[variant], className)}
    />
  );
};
